<template>
  <klaviyo />
</template>

<script>
/**
 * Vue: Analytics Index (analytics)
 * -----------------------------------------------------------------------------
 * Entry point for analytics
 *
 */

import { track } from '~/helpers/datalayer-actions';
import Klaviyo from '~global/analytics/klaviyo';

export default {
  name: 'AnalyticsIndex',

  components: {
    Klaviyo,
  },

  data() {
    return {
      scrollY: window.scrollY,
      trackedPercents: {
        25: false,
        50: false,
        75: false,
        100: false,
      },
      percents: [25, 50, 75, 100],
    }
  },

  created() {
    if (this.$variable('analytics.trackScroll') || this.$variable('request.pageType') === 'index') {
      this.initTrackedPercents(this.getScrollPercent())
      this.trackScroll()
    }

    this.trackSession()
  },

  methods: {
    /**
     * Track scroll every 25% on billie & finneas landing pages
     */
    trackScroll() {
      window.addEventListener(
        'scroll',
        () => {
          // calculate scroll direction so we can track scrolling down only
          const scrollY = window.scrollY
          const direction = scrollY > this.scrollY ? 'down' : 'up'
          this.scrollY = scrollY

          // determine which percent thresholds to track. we use an array to include any
          // skipped thresholds when the user scrolls fast
          const currentPercent = this.getScrollPercent()
          const percentsToTrack = []

          for (let index = 0; index < this.percents.length; index++) {
            const percent = this.percents[index]
            if (currentPercent >= percent) {
              if (!this.trackedPercents[percent]) {
                percentsToTrack.push(percent)
                this.trackedPercents[percent] = true
              }
            } else {
              break
            }
          }

          if (direction === 'up' || percentsToTrack.length === 0) {
            return
          }

          const isPdp = this.$variable('request.pageType') === 'product'
          percentsToTrack.forEach((percent) => {
            const eventObj = {
              event: `scroll_${percent}`,
              jh_value: percent,
              percent_scrolled: percent,
            }

            if (isPdp) {
              track({
                ...eventObj,
                event: 'pdp_scroll_depth',
                item_sku: this.$variable('product.sku'),
                item_name: this.$variable('product.title'),
                item_id: this.$variable('product.styleNo'),
              })
            } else {
              track(eventObj)
            }

            this.trackedPercents[percent] = true
          })
        },
        { passive: true },
      )
    },

    /**
     * Get percent scrolled
     */
    getScrollPercent() {
      const scrollY = window.scrollY
      const docHeight = document.documentElement.scrollHeight - window.innerHeight

      return (scrollY / docHeight) * 100
    },

    /**
     * If the user lands on the page midway, set all previous percent thresholds to `tracked` state
     * so they're skipped in future analytics scroll tracking.
     */
    initTrackedPercents(currentPercent) {
      if (currentPercent < 25) {
        return
      }
      this.percents.forEach((percent) => {
        if (percent <= currentPercent) {
          this.trackedPercents[percent] = true
        }
      })
    },

    /**
     * Track `custom_session` if session storage item doesn't exist
     */
    trackSession() {
      const SESSION_KEY = 'cnvs-session-start'
      const sessionStart = sessionStorage.getItem(SESSION_KEY)
      if (sessionStart) {
        return
      }
      sessionStorage.setItem(SESSION_KEY, Date.now())
      const event = {
        event: 'custom_session',
        jh_source: location.pathname,
        link_url: '',
      }

      if (this.$variable('request.pageType') === 'page') {
        event.link_url = location.href
      }

      track(event)
    },
  },
}
</script>
